<template>
  <div
    :data-test-id="`${props.dataTestId}-solutions`"
    class="tw-inline-flex tw-gap-1 tw-align-middle"
  >
    <div
      v-for="(service, index) in displayServices"
      :key="index"
      v-tippy="{
        content: service.isServiceEnabled
          ? $t(service.tooltipLabel)
          : $t(service.tooltipLabelUnavailable),
        placement: 'top',
      }"
      :data-test-id="
        service.isServiceEnabled
          ? `${props.dataTestId}-${service.tooltipLabel}`
          : `${props.dataTestId}-${service.tooltipLabel}-not-available`
      "
      class="tw-w-6 tw-h-6 tw-p-0.5 tw-m-0 tw-border-2 tw-bg-white tw-rounded-full tw-flex tw-items-center tw-justify-center tw-place-self-center"
      :class="
        service.isServiceEnabled
          ? 'tw-border-primary-grey-200'
          : 'tw-text-primary-grey-100 tw-border-primary-grey-100'
      "
    >
      <component :is="service.icon" color="currentColor" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, toRefs } from "vue";

export interface AvailableServicesInterface {
  isServiceEnabled: boolean;
  tooltipLabel: string;
  tooltipLabelUnavailable: string;
  icon: string;
}

interface TEnabledSolutionsQuickViewProps {
  services: AvailableServicesInterface[];
  shouldHideDisabled?: boolean;
  dataTestId: string;
}

const props = withDefaults(defineProps<TEnabledSolutionsQuickViewProps>(), {
  shouldHideDisabled: false,
  dataTestId: "dashboard-data-table-solutions", //TODO: remove this once the customers datatable is merged to `main` and update there as well!
});

const { services, shouldHideDisabled } = toRefs(props);
const displayServices = ref<AvailableServicesInterface[]>([]);

onMounted(() => {
  displayServices.value = services.value.filter(
    (service: AvailableServicesInterface) =>
      (!service.isServiceEnabled && !shouldHideDisabled.value) ||
      service.isServiceEnabled,
  );
});
</script>
